jQuery(document).ready(function ($) {

    function initMegaMenu() {

        // Remove any previous handlers
        $('.navbar-megamenu > li').off('mouseenter mouseleave click');
        $(document).off('click.megaMenuTouch');

        // Determine if desktop or mobile
        var isDesktop = $(window).width() >= 992;

        $('.navbar-megamenu > li').each(function () {
            var $li = $(this);
            var $megaMenu = $li.children('.mega-menu');

            if ($megaMenu.length === 0) return;

            if (isDesktop) {
                // Hover for desktop
                var timeout;
                $li.on('mouseenter', function () {
                    clearTimeout(timeout);
                    $megaMenu.stop(true, true).fadeIn(200);
                    $li.addClass('mega-menu-active');       // <-- add active class
                }).on('mouseleave', function () {
                    timeout = setTimeout(function () {
                        $megaMenu.stop(true, true).fadeOut(200);
                        $li.removeClass('mega-menu-active'); // <-- remove active class
                    }, 200);
                });
            } else {
                // Click/tap for mobile
                $li.children('a').on('click', function (e) {
                    e.preventDefault();

                    // Close other menus and remove their active class
                    $('.mega-menu').not($megaMenu).slideUp(200);
                    $('.navbar-megamenu > li').not($li).removeClass('mega-menu-active');

                    // Toggle this menu and active class
                    $megaMenu.slideToggle(200);
                    $li.toggleClass('mega-menu-active');
                });

                // Close if clicking outside
                $(document).on('click.megaMenuTouch', function (e) {
                    if (!$(e.target).closest('.navbar-megamenu > li').length) {
                        $('.mega-menu').slideUp(200);
                        $('.navbar-megamenu > li').removeClass('mega-menu-active');
                    }
                });
            }
        });
    }

    // Initialize on load
    initMegaMenu();

    // Reinitialize on window resize
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            initMegaMenu();
            // Close all menus on resize
            $('.mega-menu').hide();
        }, 250);
    });

});
